import DatePicker from '../../Forms/DatePicker/DatePicker';
import InputField from '../../Forms/Input/InputField';
import SelectField from '../../Forms/Input/SelectField';
import TextAreaField from '../../Forms/Input/TextAreaField';
import { useBasePurchase } from '../../../hooks/purchases/useBasePurchase';

const PaymentConditionViewSection = () => {
  const { form } = useBasePurchase();

  const isCredit = form.paymentCondition?.code === 'CREDITO';
  const termCode = form.paymentCondition?.termCode;

  return (
    <div className="mt-6 w-full rounded-sm border border-stroke bg-white p-6.5 shadow-default dark:border-strokedark dark:bg-boxdark">
      {/* Condición de pago y unidad */}
      <div className="mb-6 grid grid-cols-1 gap-4 sm:grid-cols-2">
        <SelectField
          name="paymentCondition"
          label="Condición de Pago"
          iconKey="payment"
          value={form.paymentCondition?.id || ''}
          onChange={() => {}}
          disabled
          options={
            form.paymentCondition
              ? [
                  {
                    value: form.paymentCondition.id,
                    label: form.paymentCondition.name,
                  },
                ]
              : []
          }
        />

        {isCredit && (
          <SelectField
            name="paymentCondition.term"
            label="Unidad del Plazo"
            iconKey="calendar"
            value={form.paymentCondition?.termId || ''}
            onChange={() => {}}
            disabled
            options={
              form.paymentCondition?.termId
                ? [
                    {
                      value: form.paymentCondition.termId,
                      label: form.paymentCondition.termName,
                    },
                  ]
                : []
            }
          />
        )}

        {isCredit && termCode === '01' && (
          <InputField
            name="creditDays"
            label="Días de Crédito"
            iconKey="calendar"
            type="number"
            value={form.paymentCondition?.creditDays ?? ''}
            onChange={() => {}}
            disabled
          />
        )}
        {isCredit && termCode === '02' && (
          <InputField
            name="creditMonths"
            label="Meses de Crédito"
            iconKey="calendar"
            type="number"
            value={form.paymentCondition?.creditMonths ?? ''}
            onChange={() => {}}
            disabled
          />
        )}
        {isCredit && termCode === '03' && (
          <InputField
            name="creditYears"
            label="Años de Crédito"
            iconKey="calendar"
            type="number"
            value={form.paymentCondition?.creditYears ?? ''}
            onChange={() => {}}
            disabled
          />
        )}

        {isCredit && (
          <DatePicker
            name="creditDueDate"
            label="Fecha Plazo del Crédito"
            iconKey="calendar"
            value={form.paymentCondition?.creditDueDate || ''}
            onChange={() => {}}
            disabled
          />
        )}
      </div>

      <p className="pb-2 text-sm font-medium text-black dark:text-white">
        FECHA DEL DOCUMENTO:{' '}
        <span className="font-bold">
          {form.purchaseDate || 'Fecha no disponible'}
        </span>
      </p>

      <TextAreaField
        name="comments"
        label="Comentarios (Uso Interno)"
        placeholder="Comentarios/Observaciones"
        value={form.comments || ''}
        onChange={() => {}}
        iconKey='edit'
        disabled
      />
    </div>
  );
};

export default PaymentConditionViewSection;
